// extracted by mini-css-extract-plugin
module.exports = {"icon":"burger_icon__7_OnM","line":"burger_line__Y4sG8","trigger":"burger_trigger__18I8F","fullWidth":"burger_fullWidth__5WMqg"};